import { Dialog } from 'primereact/dialog';
import React, {useEffect} from 'react';

const OfferMessageModal = ({
  modalVisible,
  setModalVisible,
  messageText,
  onClose,
}) => {
  useEffect(() => {
    if (modalVisible) {
      const timer = setTimeout(() => {
        setModalVisible(false);
      }, 2000);

      return () => clearTimeout(timer); // Clear the timer if the component unmounts or modalVisible changes
    }
  }, [modalVisible, setModalVisible]);

  
  const handleModalClose = () => {
    setModalVisible(!modalVisible);
  };
  return (
    <div className="flex justify-content-center">
    <Dialog
      modal
      visible={modalVisible}
      style={{ width: "50vw" }}
      onHide={() => {
        if (!modalVisible) return;
        handleModalClose();
      }}
      content={({ hide }) => (
        <div
            className="flex flex-column px-4 py-3 gap-4"
            style={{
              borderRadius: "12px",
              backgroundImage:
                "radial-gradient(circle at left top, #2B70D7, #1752AA)",
            }}
          >
          <div className="flex justify-content-center align-items-center gap-2">
            
              <img
                src={'Laundy_App_Icons_Gifs/SettingIcons/gift.png'}
                style={{
                  width: 35,
                height: 35
                }}
              />
              <p className=" text-xl text-white font-semibold">
              {messageText}
            </p>
          </div>
        </div>
      )}
      ></Dialog>
    </div>
  );
};

export default OfferMessageModal;
